export const useGenerateErrorPageEnabled = (): boolean => {
  return localStorage.getItem("GenerateErrorPage") === "true";
};
